'use client'
import Text from '@/app/components/common/Text'
import { Icons } from '@/app/components/ui/Icons'
import { UserData } from '@/app/types'
import { useLocalStorage } from '@uidotdev/usehooks'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useParams } from 'next/navigation'
import Script from 'next/script'
import { FC, useEffect } from 'react'
import {
	COOKIE_CONSENT_COUNTRIES,
	COOKIE_NOTICE_STORAGE_KEY,
	INIT_DATA_STORAGE_KEY,
} from '../constants'

const CookieBanner: FC = () => {
	const [showCustomCookieConsent, setShowCookieNotice] = useLocalStorage(
		COOKIE_NOTICE_STORAGE_KEY
	)
	const [userData, _] = useLocalStorage<UserData>(INIT_DATA_STORAGE_KEY)

	const t = useTranslations('Footer')
	const params = useParams()

	const handleClose = () => {
		setShowCookieNotice(false)
	}

	useEffect(() => {
		if (typeof showCustomCookieConsent !== 'undefined') return

		if (userData && !COOKIE_CONSENT_COUNTRIES.includes(userData.userCountry)) {
			setTimeout(() => {
				setShowCookieNotice(true)
			}, 1000)
		}
	}, [userData])

	return (
		<>
			{showCustomCookieConsent ? (
				<div
					className={classNames(
						'fixed bg-white	w-screen h-16 align-middle md-py-4 left-0 -bottom-full transition-all duration-500 z-50 shadow-lg border',
						{
							'!bottom-0': showCustomCookieConsent,
						}
					)}
				>
					<div className="container flex items-center h-[100%] rtl:pr-8 justify-between">
						<Text className="pe-4 text-xs md:text-sm">
							{t.rich('cookieConsent', {
								privacyPolicy: (chunks) => (
									<Link
										href={`/${params.lang}/privacy-policy`}
										className="underline"
									>
										{chunks}
									</Link>
								),
							})}
						</Text>
						<button
							onClick={handleClose}
							name="Close Cookie Banner"
							aria-label="Close Cookie Banner"
						>
							<Icons.iconClose />
						</button>
					</div>
				</div>
			) : (
				<Script
					strategy="lazyOnload"
					id="Cookiebot"
					src="https://consent.cookiebot.com/uc.js"
					data-cbid="c4f80501-886e-4f20-bf0d-592c3883d459"
					type="text/javascript"
				/>
			)}
		</>
	)
}

export default dynamic(() => Promise.resolve(CookieBanner), { ssr: false })
